import gql from 'graphql-tag';

export const DELETE_BATTLECARD = gql`
  mutation DeleteBattlecard($battlecardId: Int!, $deploymentModelId: Int!) {
    deleteBattlecard(battlecardId: $battlecardId, deploymentModelId: $deploymentModelId)
  }
`;
